import React from 'react';
import { Content } from '~/containers/styles';

export default ({ children }) => (
  <Content>
    <div className="container">{children}</div>
  </Content>
);



// WEBPACK FOOTER //
// ./resources/assets/js/components/ContentSection/ContentSection.js